// Tiny logger wrapper — only logs in development to keep production builds clean.
// Errors are always surfaced (they're real problems).
const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development';

export const log = {
  info: (...args) => { if (isDev) console.log(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  // Always surface errors, even in prod — silent failures are worse than a console line.
  error: (...args) => { console.error(...args); },
};
